import { Badge } from '@/components/ui/badge'

// Estados do processo nos tokens do DS (Iteração 1): em andamento com agente
// usa a marca, marcos que pedem ação humana usam warn, publicado ok, falha
// err e estados parados ficam neutros — a paleta crua (blue/cyan/violet/
// amber-100…) da era Polaris saiu.
const STATUS_VARIANTS: Record<string, string> = {
  draft: 'bg-secondary text-muted-foreground',
  published: 'bg-success/12 text-success dark:bg-success/15',
}

export default function StatusBadge({ status, label }: { status: string; label: string }) {
  return (
    <Badge variant="secondary" className={STATUS_VARIANTS[status] || ''}>
      {label}
    </Badge>
  )
}
